module.exports = __webpack_public_path__ + "src/assets/img/header_wissen_10_green_de.05a3a8cc.png";